import { Injectable } from '@angular/core';

@Injectable()
export abstract class RequestService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract request(options: any);
}
